import { Renderer2, inject } from "@angular/core"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"


declare type Bs5ModalOpts = {
    fullscreen?: boolean,
    drag?: boolean,
    dragTargetClass?: string
}

declare type Bs5ModalState = {
    fullscreen: boolean,
    dragSaveTransformValue: any

}

export class Bs5ModalCtrl {

    activeModal = inject(NgbActiveModal);
    renderer = inject(Renderer2);

    // default options
    opts: Bs5ModalOpts = {
        fullscreen: false,
        drag: false,
        dragTargetClass: 'modal-content'
    }

    state: Bs5ModalState = {
        fullscreen: false,
        dragSaveTransformValue: null,
    }

    constructor(options?: Bs5ModalOpts) {
        this.opts = { ...this.opts, ...options };
    }

    toggleFullscreen() {

        if (!this.opts.fullscreen || !this.opts.dragTargetClass) {
            return;
        }

        // transform: translate3d(53px, 176px, 0px);
        // 풀스크린으로 전환 시 .modal-content의 transform을 제거 후 진행해야함
        var modalContentEl = window.document.getElementsByClassName(this.opts.dragTargetClass)[0];
        this.state.fullscreen = !this.state.fullscreen;
        if (this.state.fullscreen === true) {
            this.state.dragSaveTransformValue = (modalContentEl as any).style.transform;
            this.renderer.removeStyle(modalContentEl, 'transform');
        } else {
            this.renderer.setStyle(modalContentEl, 'transform', this.state.dragSaveTransformValue);
        }
        this.activeModal.update({ fullscreen: this.state.fullscreen });
    }

}